module.exports = __webpack_public_path__ + "img/Screenshot 2021-09-17 at 12.51 1@2x.fdb7f414.jpg";